// extracted by css-extract-rspack-plugin
export default {"newsletterBox":"footer-fragment__Newsletter_newsletterBox__X7ePs"};